<template>
    <div>
        <v-layout row>
            <v-flex xs12>
                <v-container grid-list-xl fluid>
                    <v-layout row wrap>
                        <v-flex xs12 md6 lg4>
                            <h5>User Profile</h5>
                            <template v-if="userProfile">
                                <table>
                                    <tbody>
                                    <tr>
                                        <td>Name:&nbsp;</td>
                                        <td>{{ userModel.profile.displayName }}</td>
                                    </tr>
                                    <tr>
                                        <td>Email:&nbsp;</td>
                                        <td>{{ userModel.profile.email }}</td>
                                    </tr>
                                    <tr>
                                        <td>Email Verified:&nbsp;</td>
                                        <td>{{ userModel.emailVerified }}</td>
                                    </tr>
                                    </tbody>
                                </table>
                                <v-btn :to="{name: 'admin.user.profile', params: {uid: userModel.uid}}" block>Edit</v-btn>
                            </template>
                            <p v-else>User has not completed their account registration yet.</p>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
  export default {
    name: 'UserProfile',
    props: {
      firebaseUser: {
        required: true
      },
      user: {
        required: true
      },
      systemConfig: {
        type: Object,
        required: true
      },
      userModel: {
        type: Object,
        required: true
      }
    },
    data () {
      return {
        active: null
      }
    },
    computed: {
      userProfile () {
        if (!this.userModel.hasOwnProperty('profile')) return null
        return this.userModel.profile
      }
    }
  }
</script>

<style scoped>

</style>